<template>
  <div class="program-summary">
    <Header :title="pageTitle" :font-size="titleFontSize">
      <div class="header-right">
        <el-button
          class="refresh-button"
          size="small"
          icon="el-icon-refresh-right"
          circle
          @click="performSearch(1)"></el-button>
        <el-select
          v-model="bfy"
          :value="bfy"
          class="bfy-select"
          placeholder="Select Year"
          :size="searchInputSize"
          @change="performSearch(1)">
          <el-option
            v-for="item in bfyOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-input
          class="search-input"
          :class="$mq"
          :size="searchInputSize"
          clearable
          placeholder="Search by Program ID"
          suffix-icon="el-icon-search"
          v-model="programId"
          @change="performSearch(1)">
        </el-input>
      </div>
    </Header>
    <ProgramSummaryTable
      ref="programSummaryTable"
      @get-page="performSearch"
    ></ProgramSummaryTable>
  </div>
</template>

<script>
import Header from '../components/headers/MainContentHeader.vue';
import ProgramSummaryTable from '../components/tables/ProgramSummaryTable.vue';
import api from '../utils/api';
import * as Paths from '../constants/paths';

export default {
  name: 'ProgramSummary',
  components: {
    Header,
    ProgramSummaryTable,
  },
  computed: {
    titleFontSize() {
      return this.$mq === 'sm' ? '24' : '32';
    },
    searchInputSize() {
      return this.$mq === 'sm' ? 'small' : 'medium';
    },
  },
  data() {
    return {
      pageTitle: 'All Notices by Program ID',
      bfyOptions: [],
      bfy: '',
      programId: '',
    };
  },
  methods: {
    performSearch(pageNumber) {
      this.$refs.programSummaryTable.getAndSetProgramSummary(this.bfy, this.programId, pageNumber);
    },
    getAndSetBfyOptions() {
      api.get(Paths.BFY_URL()).then((response) => {
        this.bfyOptions = response.data.data;
        if (this.bfyOptions.length > 0) {
          this.bfy = this.bfyOptions[0].value;
          this.performSearch(1);
        }
      });
    },
    getAndSetAnnouncements() {
      api.get(Paths.ANNOUNCEMENT_URL()).then((response) => {
        this.announcementOptions = response.data.data;
        if (this.announcementOptions.length > 0) {
          this.announcement = this.announcementOptions[0].value;
        }
      });
    },
  },
  mounted() {
    this.getAndSetBfyOptions();
    this.getAndSetAnnouncements();
  },
};
</script>

<style scoped lang="scss">
  .program-summary {
    .header-right {
      float: right;
      margin-top: 12px;
      .refresh-button {
        padding: 6px;
        margin-left: 10px;
        color: #FFFFFF;
        background-color: #F39404;
        border-color: #F39404;

        /deep/ .el-icon-refresh-right {
          font-size: 16px;
        }

        -webkit-transition-duration: 0.7s;
        -moz-transition-duration: 0.7s;
        -o-transition-duration: 0.7s;
        transition-duration: 0.7s;
        -webkit-transition-property: -webkit-transform;
        -moz-transition-property: -moz-transform;
        -o-transition-property: -o-transform;
        transition-property: transform;
        &:hover {
          -webkit-transform:rotate(630deg);
          -moz-transform:rotate(630deg);
          -o-transform:rotate(630deg);
        }
      }
      .bfy-select {
        margin-left: 10px;
        width: 125px;
      }
      .search-input {
        margin-left: 10px;
        width: 220px;
        &.sm {
          width: 200px;
        }
      }
    }
  }
</style>
